import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * Modal de confirmação reutilizável
 * Substitui window.confirm para melhor UX
 */
function ConfirmModal({
  show,
  onHide,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  variant,
  isLoading,
}) {
  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Header
        closeButton
        style={{ backgroundColor: '#008080', color: 'white' }}
      >
        <Modal.Title style={{ fontSize: '1rem' }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ marginBottom: 0 }}>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isLoading}>
          {cancelText}
        </Button>
        <Button variant={variant} onClick={onConfirm} disabled={isLoading}>
          {isLoading ? 'Aguarde...' : confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ConfirmModal.defaultProps = {
  show: false,
  title: 'Confirmação',
  message: 'Deseja confirmar esta ação?',
  confirmText: 'Confirmar',
  cancelText: 'Cancelar',
  variant: 'danger',
  isLoading: false,
};

ConfirmModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  variant: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default ConfirmModal;
